// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-footnote-caption_root__PsV9N"};